export default {
  "meeting": {
    applyrecurring: 'سيتم تطبيق التغييرات على الجدول المتكرر الجديد. ولن تتأثر الاجتماعات السابقة.',
    recurrenceDescribeTwo: 'يتكرر كل {loopPulse} أسابيع في {week} بدءًا من {start} حتى {end}',
    wanttodeletethemeetingfollowTwo: 'هل تريد حذف الاجتماع المحدد وجميع الاجتماعات المتكررة اللاحقة؟',
    loopCycleSelectTips: 'يرجى تحديد يوم الأسبوع للتكرار.',

    export: 'تصدير',
    exportMeetingFileFuncTipsTitle: 'تأكيد التصدير',
    exportMeetingFileFuncTipsContentOne: 'لم يتم تطبيق أي عوامل تصفية. سيقوم النظام بتصدير سجلات الاجتماعات للسنة الحالية افتراضيًا.',
    exportMeetingFileFuncTipsContentTwo: 'لتصدير الاجتماعات من فترة زمنية مختلفة، يرجى تطبيق عوامل التصفية المطلوبة قبل التصدير.',

    myMeetingSearch: 'اجتماعاتي',
    meetingTimeSearch: 'وقت الاجتماع',
    meetingRoomsSearch: 'غرفة الاجتماعات',

    Recurring: 'متكرر:',
    wanttodeletethemeetingfollow: 'هل أنت متأكد من رغبتك في حذف هذا الاجتماع وجميع الاجتماعات التالية؟',
    endTimeCannotBeforeBeginTime: 'لا يمكن أن يكون تاريخ الانتهاء أسبق من تاريخ البدء',
    Thismeeting: 'هذا الاجتماع',
    Recurringmeeting: 'اجتماع متكرر',
    Checkin: 'تسجيل الحضور:',
    checkinTip: 'بعد التفعيل، يمكن للمشاركين تسجيل الحضور عن طريق مسح رمز QR الخاص بجدولة الغرف.',
    Recurrence_Setrecurrence: 'إعداد التكرار',
    Recurrence_Start: 'البداية',
    Recurrence_RepeatEvery: 'تكرار كل',
    Recurrence_Week: 'أسبوع',
    Recurrence_end: 'النهاية',
    recurrenceDescribe: 'يحدث كل {week} بدءًا من {start} حتى {end}',
    Recurrence_DoesnotRepeat: 'عدم التكرار',
    Recurrence_Weekly: 'أسبوعيًا',

    AddressBookUser: 'مستخدم',
    AddressBookPhonebook: 'دفتر العناوين',

    RoomByPeopleNum1: 'شخصان أو أقل',
    RoomByPeopleNum2: '3-6 أشخاص',
    RoomByPeopleNum3: '7-10 أشخاص',
    RoomByPeopleNum4: '11-15 شخصًا',
    RoomByPeopleNum5: '16-20 شخصًا',
    RoomByPeopleNum6: '21-30 شخصًا',
    RoomByPeopleNum7: 'أكثر من 30 شخصًا',

    whoAreBound: 'سيتمكن المستخدمون المرتبطون بحساب النظام من رؤية الاجتماع في تقويم النظام. المستخدمون الذين أدخلوا بريدًا إلكترونيًا سيتلقون إشعارات عبر البريد. لاستلام الإشعارات، يرجى إكمال المعلومات في [ملفي الشخصي].',

    AttendessMeeting: 'الحضور:',
    SelectAttendessMeetingTip: 'اختر المشاركين',

    MeetingFilter: 'تصفية الاجتماعات',
    HostedbyMe: 'أنا المنظم',
    Invitedby: 'أنا مشارك',
    Otherby: 'أخرى',

    "AddressIsDuplicated": "البريد الإلكتروني لجهة الاتصال مكرر",
    "meetingExpired": "منتهي الصلاحية",
    titlePhoneFormat: 'يمكن أن يحتوي الهاتف فقط على الأرقام و() + و -.',
    "selectField": "يرجى اختيار ملف",
    "Limit255": "لا يمكن أن يتجاوز اسم الملف 255 حرفًا",
    "nameLimit25": "لا يمكن أن يتجاوز الاسم 25 حرفًا",
    "emailLimit50": "لا يمكن أن يتجاوز البريد الإلكتروني 50 حرفًا",
    "emailFormatError": "يرجى إدخال بريد إلكتروني صالح",
    "phoneLimit11": "يمكن أن يحتوي رقم الهاتف على ما يصل إلى 11 رقمًا",
    "ParticipantsEmail": "بريد المشارك:",
    "listIsEmpty": "القائمة فارغة",
    "Startimporting": "بدء الرفع",
    "Selectfile": "اختر ملفًا",
    "Importfile": "استيراد ملف",
    "ImportfileTip": "*يتم دعم استيراد ملفات CSV بتنسيق Outlook (.csv) أو ملفات vCard (.vcf) فقط.",
    "addParticipants": "إضافة مشارك",
    "multiselectdeselect": "تلميح حذف الوسم",
    "multiselectselected": "تلميح التحديد",
    "enterOrSelectALabel": "اختر بريد المشارك",
    "deleTitleContact": "هل أنت متأكد أنك تريد حذف جهة الاتصال هذه؟",
    "delTitleContactContent": "حذف جهة الاتصال؟",
    "deleteContactTitle": "يرجى اختيار جهة الاتصال المراد حذفها",
    "editcontact": "تعديل جهة الاتصال",
    "Name": "الاسم",
    "email": "البريد الإلكتروني",
    "telephoneNumber": "الهاتف",
    "Addcontact": "إضافة جهة اتصال",
    "Importcontactfile": "استيراد جهات الاتصال",
    "AddressBook": "دفتر العناوين",
    "Participants": "المشاركون:",

    bindTipContent:"هذه المنظمة قد ربطت بالفعل تقويمًا تابعًا لجهة خارجية. يُرجى جدولة الاجتماعات عبر Outlook/Teams.",
    Productupdatenews: 'م إصدار تحديث إصدار جديد. ',
    bookingPerson: 'تم الحجز بواسطة',
    "DeleteMeeting": "حذف الاجتماع",
    "wanttodeletethemeeting": "هل تريد حذف الاجتماع؟",
    "hasbeendeleted": "تم حذف الاجتماع",
    "theMeetingWasAborted": "إنهاء الاجتماع مبكرًا",
    "theMeetingWasAbortedContent": "هل تريد إنهاء الاجتماع مبكرًا؟",
    "determineTheAbortTask": "إنهاء الاجتماع مبكرًا",
    "theMeetingEndedEarly": "تم إنهاء الاجتماع مبكرًا.",
    "with": "مع",
    "Other": "آخر",
    "tasks": "تضارب المهام",
    "conflict": "الوقت التالي للاجتماع يتعارض:",
    "meetConflicts": "لا يمكن اختيار الأوقات السابقة",
    "itIsNotAllowedToSelectThePastTime": "تم اختياره",
    "selected": "يرجى اختيار ما لا يزيد عن 5 غرف للاجتماع",
    "noOverFive": "آراء الموافقة",
    "approvalOpinions": "بمجرد تجاوز الحد الزمني، لا يمكن اختياره",
    "beyondTheTimeLimitItCannotBeSelected": "شهر البداية",
    "startMonth": "إلى",
    "to": "شهر النهاية",
    "stopMonth": "لا يوجد بداية",
    "didnTStart": "قيد التنفيذ",
    "ONGOING": "انتهى",
    "ENDED": "تم",
    "hasBeen": "الحجز",
    "booking": "الموافقة",
    "Approval": "غرفة الاجتماع",
    "MeetingRoom": "جميع الغرف",
    "AllRoom": "متاحة",
    "Available": "بدء الاجتماع",
    "Initiate": "موافقة الاجتماع",
    "MeetingApproval": "الشهر السابق",
    "PreviousMonth": "اليوم",
    "Today": "الشهر المقبل",
    "NextMonth": "السنة/الشهر",
    "YearMonth": "عرض الوقت",
    "TimeDisplay": "اختصار عنوان الاجتماع",
    "MeetingTitleAbbreviation": "بدء الاجتماع",
    "InitiateMeeting": "الاجتماعات القادمة",
    "PendingMeetings": "جميع الاجتماعات",
    "AllMeetings": "لا توجد اجتماعات للحضور في الوقت الحالي",
    "noMeetings": "لم يبدأ",
    "NotStarted": "المنظم",
    "Organizer": "التاريخ والوقت",
    "MeetingDateTime": "الموقع",
    "MeetingLocation": "موضوع الاجتماع",
    "MeetingSubject": "الأشخاص المدعوون",
    "Invited": "الأشخاص المقبولون",
    "PeopleAccepted": "تحرير الاجتماع",
    "EditMeeting": "إلغاء الاجتماع",
    "CancelMeeting": "بدء/تحرير الاجتماع",
    "InitiateEditMeeting": "الموضوع",
    "Subject": "الموضوع",
    "Presenter": "المقدم :",
    "DateTime": "التاريخ والوقت",
    "TimeAndZone": "المنطقة الزمنية",
    "Attendees": "الحضور",
    "Addrequiredattendees": "إضافة الحضور المطلوب",
    "SelectRooms": "اختيار الغرف",
    "Reminder": "تذكير",
    "Remindbeforestart": "تذكير قبل البدء",
    "Confirm": "تأكيد",
    "topic": "الموضوع :",
    "topicplace": "عنوان الاجتماع الجديد :",
    "speaker": "المقدم :",
    "speakerplace": "يرجى إدخال معلومات المقدم",
    "DateAndTime": "التاريخ والوقت :",
    "TimeZone": "المنطقة الزمنية",
    "EndDate": "تاريخ الانتهاء",
    "Rooms": "الغرف :",
    "Notes": "ملاحظات :",
    "MeetingRoomApproval": "موافقة غرفة الاجتماعات",
    "PendingApproval": "موافقة قيد الانتظار",
    "Approved": "تمت الموافقة",
    "nopendingapprovals": "لا توجد موافقات معلقة",
    "Applicant": "المتقدم",
    "UsageTime": "مدة الاستخدام",
    "ApprovalResult": "نتيجة الموافقة",
    "ApprovalComments": "تعليقات الموافقة",
    "Approve": "الموافقة",
    "Reject": "الرفض",
    "Search": "البحث",
    "Filter": "التصفية",
    "scanTheQRCodeToSignIn": "امسح رمز الاستجابة السريعة للتسجيل"
  },
  "NPS": {
    "Relay": "الترحيل",
    "RelaySettings": "إعدادات الترحيل",
    "DevicePower": "التحكم في طاقة الجهاز",
    "DeviceElevation": "تحكم في الارتفاع",
    "LinageWithNPSPower": "الارتباط مع طاقة NPS",
    "PresentationSwitch": "مفتاح العرض التقديمي",
    "Duplicate": "مضاعفة",
    "LinkagewithNPSPowe": "الارتباط مع طاقة NPS",
    "npsTooltip": "يمكن استدعاء أجهزة USB فقط من قبل جهاز كمبيوتر مضيف متصل بـ HDMI OUT 1.",
    "nmpTooltip": "انقر على زر 'مضاعفة' لعرض محتوى الشاشة على شاشات أخرى، مما يزامن العرض عبر شاشات متعددة."
  },
  "textTemplate": {
    "template2513": "بث حالة الطوارئ من الحريق",
    "template2514": "يرجى الإخلاء من مخرج الطوارئ ومخرج الحريق إلى مكان آمن وفقًا لخطة الهروب من الحريق.",
    "moreTemplate": "تم الوصول إلى الحد الأقصى للقوالب",
    "add": "إضافة",
    "SetTemplate": "تعيين القالب",
    "Emergency": "الطوارئ",
    "General": "عام",
    "BroadcastDevices": "جهاز البث:",
    "selectBroadcastDevices": "يرجى اختيار أجهزة البث",
    "All": "الكل",
    "AddTemplate": "إضافة قالب",
    "EditTemplate": "تعديل القالب",
    "deleteTemplage": "هل أنت متأكد أنك تريد حذف القالب المحدد؟",
    "title": "حذف القالب",
    "selectTemplage": "يرجى اختيار قالب!",
    "DeleteCancelled": "تم إلغاء الحذف!",
    "DeletedSuccessfully": "تم الحذف بنجاح!",
    "noData": "لا يمكن استخدام القالب، انقر على الزاوية اليمنى العليا لإضافة قالب.",
    "TemplateTitle": "عنوان القالب:",
    "BroadcastType": "نوع البث:",
    "BroadcastTypeDialog": "نوع البث:",
    "selectBroadcastType": "يرجى اختيار نوع البث",
    "BroadcastDuration": "مدة البث:",
    "BroadcastDevice": "جهاز البث:",
    "BroadcastContent": "محتوى البث:"
  },
  "common": {
    "mediaTimeStateNotifyErrorTitle": "خطأ!",
    "mediaTimeStateNotifyErrorContent": "انتهت صلاحية خدمة البث الخاصة بك، يرجى الاتصال بوكيلك لتجديدها في الوقت المحدد.",
    "mediaTimeStateNotifyWarnTitle": "تنبيه!",
    "mediaTimeStateNotifyWarnContent": "أنت حالياً في حالة تجريبية ويمكنك بث وبث مباشر على 3 أجهزة طرفية كحد أقصى.",
    "mediaTimeStateNotifySuccessTitle": "تجديد ناجح",
    "mediaTimeStateNotifySuccessContent": "خدمة البث الخاصة بك جاهزة للاستخدام الطبيعي. شكراً.",
    "company": "اسم الشركة:",
    "tableAddress": "العنوان:",
    "createTime": "تاريخ الإنشاء:",
    "email": "البريد الإلكتروني:",
    "phone": "الهاتف:",
    "Trial": "تجربة",
    "TrialWorkstation": "أنت حالياً في حالة تجريبية ويمكنك بث وبث مباشر على 3 أجهزة طرفية كحد أقصى.",
    "Normal": "طبيعي",
    "NormalWorkstation": "فترة صلاحية خدمة البث الخاصة بك من",
    "to": "إلى",
    "Advent": "قريباً",
    "AdventWorkstationOne": "ستنتهي خدمة البث الخاصة بك في",
    "AdventWorkstationTwo": "، يرجى الاتصال بوكيلك لتجديدها في الوقت المحدد للاستخدام الطبيعي.",
    "Expired": "منتهية الصلاحية",
    "ExpiredWorkstation": "انتهت صلاحية خدمة البث الخاصة بك، يرجى الاتصال بوكيلك لتجديدها في الوقت المحدد."
  },
  "route": {
    "dashboard": "لوحة القيادة",
    "i18n": "I18n",
    "Devices": "الأجهزة",
    "Broadcast": "البث",
    "Schedule": "الجدول",
    "Resources": "الموارد",
    "Live": "البث المباشر",
    "meetings": "الاجتماع"
  },
  "navbar": {
    "updates":"أحدث التحديثات",
    "logOut": "تسجيل الخروج",
    "screenfull": "ملء الشاشة",
    "oprofile": "ملفي الشخصي",
    "settings": "الإعدادات",
    "language": "اللغة",
    "BackTianwa": "العودة إلى Tianwa",
    "newUserGuide": "دليل المستخدم الجديد"
  },
  "feedback": {
    "Feedback": "التعليقات",
    "email": "يرجى ترك بريدك الإلكتروني للحصول على تعليقاتنا.",
    "content": "مرحبًا واترك رسائل لتحسين منتجاتنا. شكرًا لتعليقاتك.",
    "submit": "إرسال",
    "emailNoEmpty": "لا يمكن أن يكون البريد الإلكتروني فارغًا",
    "emailTrueRule": "يرجى إدخال التنسيق الصحيح للبريد الإلكتروني",
    "contentNoEmpty": "لا يمكن أن يكون المحتوى فارغًا",
    "feedbackSuccess": "تم إرسال التعليقات بنجاح",
    "feedbackFailed": "فشل إرسال التعليقات",
    "emailNoChinese": "لا يمكن أن يحتوي البريد الإلكتروني على أحرف صينية",
    "emailLength": "من 5 إلى 50 حرفًا في الطول",
    "emailSpecialString": "لا يمكن أن يحتوي البريد الإلكتروني على سلاسل خاصة"
  },
  "login": {
    checkPasswordTitleTwo: 'يرجى تعيين كلمة مرور لا تقل عن 6 أحرف، تحتوي على أحرف وأرقام. يمكن استخدام الرموز الخاصة (بدون قيود).',
    captcha: 'رمز التحقق',
    checkPasswordTitle: 'يجب أن تتكون كلمة المرور من 6 أحرف على الأقل ولا يمكن أن تكون أرقامًا فقط',
    "title": "أهلاً وسهلاً",
    "logIn": "تسجيل الدخول",
    "consoleLogin": "تسجيل الدخول إلى وحدة التحكم",
    "username": "اسم المستخدم",
    "password": "كلمة المرور",
    "any": "أي",
    "thirdparty": "أو تسجيل الدخول باستخدام",
    "thirdpartyTips": "لا يمكن محاكاته محليًا، لذا يرجى دمجه مع محاكاة الأعمال الخاصة بك!",
    "placeholder": ["اسم المستخدم", "كلمة المرور", "رمز التحقق"],
    "userNameTitle": "اسم المستخدم خاطئ!",
    "forget": "هل نسيت؟",
    "loginTitle0": "تم تسجيل الدخول بنجاح!",
    "loginTitle1000": "اسم المستخدم أو كلمة المرور خاطئة!",
    "loginTitle1001": "يجب تعبئة اسم المستخدم وكلمة المرور!",
    "loginTitle1002": "يجب تعبئة رمز التحقق!",
    "loginTitle1003": "حالة المستخدم غير قانونية، فشل في تسجيل الدخول!",
    "loginTitle1004": "خطأ في رمز التحقق!",
    "loginTitle1005": "لم تقم بتسجيل الدخول، يرجى تسجيل الدخول أولاً!",
    "loginTitle1006": "كلمة المرور غير متطابقة!",
    "loginTitleUserName": "يجب تعبئة اسم المستخدم!",
    "loginTitlePwd": "يجب تعبئة كلمة المرور!",
    "loginTitleVercode": "يجب تعبئة رمز التحقق!",
    "titleLoginNameFormat": "يجب أن يتكون الحساب من أحرف أو أحرف وأرقام.",
    "privacy": "Q-NEX User Privacy Policy",
    "privacyContent": "Agree to",
    "_zh": "中文(简体)",
    "_en": "_English",
    "_ko": "한국어",
    "_zh_ft": "中文(繁體)"
  },
  "home": {
    "btnDevices": "الأجهزة",
    "btnRoadcast": "البث",
    "btnResources": "الموارد",
    "btnLive": "البث المباشر",
    "meetings": "الاجتماع",
    "todaySchedule": "جدول اليوم",
    "allSkedules": "جميع الجداول",
    "details": "التفاصيل",
    "btnStart": "بدء",
    "titleContent": "مرحبًا! وحدة تحكم Q-NEX في خدمتك. دعونا نبدأ!",
    "btnExit": "خروج"
  },
  "devices": {
    ptzCamera:'كاميرا PTZ',
    "start": "ابدأ",
    "stop": "توقف",
    "nmpPowerOff_mandatory": "في البث (غير إلزامي)",
    "nmpPowerOff_nomandatory": "في البث (غير إلزامي). هل تريد متابعة التنفيذ؟",
    "nmpsPowerOff_mandatory": "بعض أجهزة NMP في البث (إلزامي).",
    "nmpsPowerOff_nomandatory": "بعض أجهزة NMP في البث (غير إلزامي). هل تريد متابعة التنفيذ؟",
    "reset": "إعادة تعيين",
    "displayedInTheControlArea": "معروض في مركز التحكم",
    "dragOrder": "سحب الترتيب",
    "areaSettingTwoNotice": "*يتم عرض التحكم في RS232 و AC والتحكم عن بعد في مركز التحكم حسب حالة الربط في NMP في لوحة القيادة.",
    "areaSettingThreeNotice": "*يتم عرض التحكم في CBX في مركز التحكم حسب حالة الربط في NMP في لوحة القيادة.",
    "controlSet": "إعدادات مركز التحكم",
    "vcbNoLine": "لا يوجد جهاز CBX متصل بالإنترنت",
    "vcbNoBound": "لا يوجد جهاز CBX مرتبط",
    "tscNoBound": "RS232 في TSC غير مرتبط بأي بيانات. يرجى إعلام المسؤول لربطه في لوحة القيادة.",
    "light": "التحكم في الطاقة",
    "vcbpower": "الطاقة",
    "rs232Control": "التحكم التسلسلي",

    "CBX": {
    "powerSupplyON": "تشغيل",
    "powerSupplyOFF": "إيقاف التشغيل",
    "lockScreenON": "قفل",
    "lockScreenOFF": "فتح القفل",
    "childLockON": "قفل الأطفال مفعّل",
    "childLockOFF": "قفل الأطفال غير مفعّل",
    "energySavingON": "توفير الطاقة مفعّل",
    "energySavingOFF": "توفير الطاقة غير مفعّل",
    "signalSourceSwitchingON": "OPS",
    "signalSourceSwitchingOFF": "Android",
    "volumeAdjustment": "مكبر الصوت",
    "brightAdjustment": "السطوع",
    "other": "الميزات الأخرى..."
  },


    "InterfaceOne": "الواجهة واحدة",
    "InterfaceTwo": "الواجهة اثنان",
    "abcStyleP": "عذراً! لا يمكن اختيار TSC و (NMP, MBX, NPS, NDP100, NDP500) في نفس الوقت",
    "masterControl": "الرئيسية",
    "powerSupply": "الطاقة",
    "RecordingControl": "تحكم التسجيل",
    "RecordingControlSystem": "نظام التقاط المحاضرات",
    "LiquidCrystal": "شاشة LCD التفاعلية",
    "projector": "جهاز العرض",
    "othertype": "آخر",
    "lockScreen": "القفل",
    "childLock": "قفل الأطفال",
    "energySaving": "توفير الطاقة",
    "signalSourceSwitching": "مصدر الإدخال",
    "volumeAdjustment": "مكبر الصوت",
    "brightAdjustment": "السطوع",
    "other": "الميزات الأخرى",
    "otherFunction": "الوظيفة",
    "send": "إرسال",
    "ON": "ON",
    "OFF": "OFF",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_MAGNETICLOCK": "MAGNETICLOCK",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    "_AIR": "مكيف الهواء",
    "titleDevices": "مرشح المجموعات:",
    "content": "بحث",
    "selectALL": "اختيار الكل",
    "SelectRecentPage": "اختيار الصفحة الحالية",
    "controlPanel": "مركز التحكم",
    "displayInputSwitch": "مفتاح إدخال العرض",
    "chooseINPUTSources": "اختيار مصادر الإدخال",
    "speakerVolume": "حجم الصوت",
    "bass": "الباس",
    "treble": "التريبل",
    "MICVolume": "حجم الميكروفون",
    "AirConditioning": "مكيف الهواء",
    "model": "النموذج",
    "setTemp": "درجة الحرارة المحددة",
    "fanSpeed": "سرعة المروحة",
    "bold": "التأرجح",
    "projectionScreen": "شاشة العرض",
    "electronicLock": "القفل الكهربائي",
    "electronicLock1": "القفل الكهربائي",
    "selectDevices": "يرجى اختيار جهاز أو مجموعة من الأجهزة",
    "isCompelType": "تعذر التحكم في الجهاز بسبب البث الإجباري، يرجى المحاولة لاحقًا.",
    "mainPower": "الطاقة الرئيسية",
    "extraPower": "الطاقة الإضافية",
    "power": "الطاقة",
    "hdmiBroadcast": "البث",
    "equipmentState1": "تشغيل",
    "equipmentState2": "إيقاف",
    "equipmentState3": "غير متصل",
    "main": "رئيسي",
    "external": "خارجي",
    "ProjectionScreen": "شاشة العرض",
    "UP": "اعلى",
    "DOWN": "اسفل",
    "LOCK": "قفل",
    "UNLOCK": "فتح القفل",
    "PleaseDevice": "يرجى اختيار الجهاز أو الأجهزة على اليسار",
    "RemoteControl": "التحكم عن بعد",
    "Action": "إجراء",
    "Devicefilter": "مرشح الجهاز",
    "DeviceStatus": "الحالة",
    "DeviceType": "النوع",
    "currentAudioSource": "المصدر الصوتي الحالي",
    "audioSwitching": "مفتاح إخراج الصوت"
  },
  "broadcast": {
    "isBoarding": "(في البث)",
    "last3Days": "آخر 3 أيام",
    "last7Days": "آخر 7 أيام",
    "last30Days": "آخر 30 يومًا",
    "historyRecord": "التاريخ",
    "SelectDestination": "1.اختار الوجهة",
    "BroadcastingConsole": "2.وحدة تحكم البث",
    "Notification": "إشعار",
    "btnStop": "إيقاف",
    "btnStart": "بدء",
    "Letters60": "(أقل من 60 حرفًا)",
    "Letters300": "(أقل من 300 حرف)",
    "LastingTime": "الوقت المستمر:",
    "Title": "العنوان:",
    "Content": "المحتوى:",
    "Cannotquit": "البث الإجباري",
    "ChooseMedia": "اختيار ملف وسائط",
    "Broadcasting": "البث",
    "dialogTitle": "موارد الفيديو والصوت",
    "SortBy": "ترتيب حسب",
    "btnBake": "الرجوع إلى السابق",
    "cancel": "إلغاء",
    "confirm": "تأكيد",
    "save": "حفظ",
    "coxAll": "الكل",
    "PublicCloud": "التخزين العام",
    "IndividualCloud": "التخزين الشخصي",
    "selFile": "يرجى اختيار ملف أو مجموعة.",
    "StopBroadcast": "إيقاف البث",
    "StartBroadcasting": "بدء البث",
    "StopBroadcasting": "إيقاف البث",
    "ForceQuit": "إيقاف قسري",
    "PleaseMediaFile": "يرجى اختيار ملف وسائط",
    "PleaseDevice": "يرجى اختيار جهاز",
    "broadcast_0": "بدء البث",
    "broadcast_2500": "يتجاوز الحد الأقصى لعدد الأجهزة المتصلة بخادم الوسائط",
    "broadcast_2501": "خطأ في ملف البث",
    "broadcast_2502": "تم إنهاء البث",
    "broadcast_2503": "تعذر الحصول على معلومات من خادم الوسائط",
    "broadcast_2510": "تنبيه! أنت حاليا في حالة تجريبية، يمكن لما يصل إلى 3 أجهزة طرفية تلقي أوامر البث. يرجى التحقق من عدد الأجهزة التي اخترتها.",
    "broadcast_2018": "تم إيقاف خدمة البث.",
    "broadcast_2019": "انتهت صلاحية خدمة البث.",
    "broadcast_2512": "تجاوز الحد الأقصى لعدد القوالب.",
    "broadcast_2513": "بث حالة الطوارئ في حال الحريق.",
    "broadcast_2514": "يرجى الإخلاء من الخروج الطارئ ومخرج الحريق إلى مكان آمن وفقًا لخطة الهروب من الحريق.",
    "broadcast_2006": "لم يتم العثور على جهاز.",
    "broadcast_2": "خدمة القرص غير طبيعية.",
    "broadcast_2515": "اختر جهازًا لا يحتوي على إمكانيات البث.",
    "broadcast_2516": "اختر ملفات تتجاوز الحد الأقصى المدعوم من الدقة لـ NMP.",
    "broadcast_2517": "اختر ملفات تتجاوز الحد الأقصى المدعوم من الدقة لـ NDP500.",
    "broadcast_Title": "تنبيه البث.",
    "broadcast_TitleNDP500": "تنبيه البث NDP500.",
    "broadcast_content": "يدعم الجهاز حتى 4K@30FPS، مع دقة مثالية 1080P@30FPS.",
    "broadcast_contentNDP500": "يدعم NDP500/600 حتى 1080P@30FPS، مع دقة مثالية 720P@30FPS.",
    "broadcast_noSupported": "الفيديوهات المختارة التالية غير مدعومة للبث:",
    "broadcast_noSupportedNDP500": "الفيديوهات المختارة التالية غير مدعومة للبث على NDP500/600:"
  },
  "resources": {
    "uploadNameLengthError": "اسم الملف الذي تم رفعه لا يمكن أن يتجاوز 100 كلمة!",
    "onUploadFile": "لا توجد ملفات للرفع",
    "open": "فتح",
    "fold": "طي",
    "close": "إغلاق",
    "PublicCloud": "التخزين العام",
    "IndividualCloud": "التخزين الشخصي",
    "TransfersHistory": "تاريخ التحويلات",
    "btnDownload": "تنزيل",
    "btnDelete": "حذف",
    "btnUploadFile": "رفع الملف",
    "btnNewFolder": "مجلد جديد",
    "btnBake": "الرجوع إلى السابق",
    "coxAll": "الكل",
    "uploadError": "حجم الملف الذي يتم رفعه لا يمكن أن يتجاوز 1 جيجابايت!",
    "MD5": "التحقق من MD5",
    "merge": "دمج",
    "transcoding": "التحويل البرمجي",
    "uploadFailed": "فشل الرفع",
    "fileError": "خطأ في قراءة الملف، يرجى التحقق من الملف.",
    "tableName": "الاسم",
    "tableSize": "الحجم",
    "tableType": "النوع",
    "tableTimeAdded": "وقت الإضافة",
    "tableAction": "الإجراء",
    "btnRename": "إعادة التسمية",
    "btnMoveTo": "نقل إلى...",
    "ClearAll": "مسح الكل",
    "cancel": "إلغاء",
    "confirm": "تأكيد",
    "save": "حفظ",
    "addSuccess": "تم الإضافة بنجاح!",
    "addError": "فشل في الإضافة!",
    "editSuccess": "تم التعديل بنجاح!",
    "editError": "فشل في التعديل!",
    "delSuccess": "تم الحذف بنجاح!",
    "delError": "فشل الحذف!",
    "diskError3000": "تم تجاوز الحجم الإجمالي للمساحة، فشلت العملية!",
    "diskError3001": "تم تجاوز كمية المساحة العامة المستخدمة، فشلت العملية!",
    "diskError3002": "تم تجاوز كمية المساحة الفردية المستخدمة، فشلت العملية!",
    "diskError3003": "تعذر العثور على البيانات، يرجى التحقق مما إذا كان الخادم الإعلامي مرتبطًا!",
    "diskError3004": "اسم المجلد موجود بالفعل!",
    "diskError3005": "فشل الحصول على المجلد!",
    "diskError3006": "لا يمكن إنشاء أكثر من 99 مجلدًا في نفس المستوى!",
    "diskError3007": "اسم الملف نفسه موجود وفشل التعديل!",
    "diskError3008": "اسم المجلد نفسه موجود وفشل التعديل!",
    "diskError3009": "يتجاوز الملف المساحة المتبقية وفشل التحميل!",
    "diskError3010": "فشل في تحميل الملف!",
    "diskError3011": "فشل التحقق من الملف، يرجى إعادة تحميل الملف!",
    "diskError3012": "فشل في الحصول على عنوان السحابة الخاصة، فشلت العملية!",
    "diskError3013": "لا يمكن أن تتجاوز مجموعات الملفات المتعددة 100 ميجابايت، يرجى تنزيل الملفات الكبيرة بشكل منفصل!",
    "diskError3014": "فشل في الضغط، يرجى اختيار الملف للتحميل مرة أخرى!",
    "diskError3015": "أنت بحاجة إلى إذن لتنفيذ هذا الإجراء",
    "downloadError": "فشل في التنزيل!",
    "mobileError": "فشل في التحريك!",
    "root": "جميع الملفات",
    "Name": "الاسم",
    "Size": "الحجم",
    "Type": "النوع",
    "uploadFile": "تحميل الملف",
    "newFolder": "مجلد جديد",
    "tableTime": "الوقت",
    "permission": "أذونات غير كافية!",
    "notifyTitle": "الإشعار",
    "notifyContent": "ليس لدى المستخدم أذونات كافية للوصول إليها!",
    "sortFileName": "اسم الملف",
    "sortTime": "الوقت",
    "sortSize": "الحجم",
    "sortType": "النوع",
    "moveTo": "نقل إلى",
    "test": "جديد",
    "delTitle": "هل تريد حذف؟",
    "delTitleContent": "سيتم حذف المحتويات المحددة من قاعدة البيانات. لا يمكن التراجع عن العملية. هل أنت متأكد أنك تريد المتابعة؟",
    "delCancelButton": "إلغاء",
    "delConfirmButton": "تأكيد"
  },
  "userMge": {
    "userName": "اسم المستخدم:",
    "jobNumber": "رقم الموظف:",
    "email": "البريد الإلكتروني:",
    "phone": "الهاتف:",
    "group": "المجموعة:",
    "oldPassword": "كلمة المرور القديمة:",
    "newPassword": "كلمة المرور الجديدة:",
    "confirmNewPassword": "تأكيد كلمة المرور الجديدة:",
    "btnSave": "حفظ التغييرات",
    "titleChangePassword": "تغيير كلمة المرور",
    "titleMyProfile": "ملفي الشخصي",
    "name": "اللقب:",
    "error1400": "الحساب (المخصص) موجود بالفعل، فشلت العملية!",
    "error1401": "الحساب (المولد من النظام) موجود بالفعل، فشلت العملية!",
    "error1402": "المجموعة غير موجودة، فشل الاستيراد!",
    "error1403": "خطأ في البيانات",
    "error1404": "الأذونات غير كافية",
    "selUser": "يرجى اختيار مستخدم!",
    "error1405": "فشل في الحصول على الدور",
    "error1406": "تنسيق بيانات معلومات المستخدم المستوردة غير صحيح",
    "error1407": "البريد الإلكتروني موجود بالفعل، فشلت العملية.",
    "error1408": "الهاتف موجود بالفعل، فشلت العملية.",
    "editSuccess": "تم الحفظ بنجاح!",
    "ChangePassword": "تغيير كلمة المرور",
    "UserPrivacyAgreement": "سياسة الخصوصية للمستخدم"
  },
  "information": {
    "_2602": "الجهاز غير متصل",
    "_2603": "فشل البث",
    "_2604": "تم قطع البث",
    "_2605": "مساحة التخزين ممتلئة",
    "_2606": "منذ دقائق",
    "_2607": "منذ ساعات",
    "_2609": "فشل، من فضلك ",
    "_2609_a": "انقر هنا ",
    "_2609_time": "للتعامل معها في الوقت المناسب",
    "userType": "المشرف",
    "unreadNoticeFirst": "قراءة الإشعار أولاً",
    "sortByTime": "ترتيب حسب الوقت",
    "coxRead_1": "تمت القراءة",
    "coxRead_0": "غير مقروء",
    "allCoxRead": "تحديد الكل كمقروء",
    "load": "جارٍ التحميل...",
    "noData": "لا توجد بيانات أخرى",
    "viewALLMessages": "عرض جميع الرسائل"
  },
  "input": {
    "select": "يرجى الاختيار",
    "thisField": "يجب ملء هذا الحقل.",
    "titleShooleNub60": "أقل من 60 حرفًا",
    "titleShooleNub300": "أقل من 300 حرف",
    "Offline": "غير متصل"
  },
  "schedule": {
    "OnlyManual": "فقط يدوي",
    "runStartNow": "تشغيل المهمة",
    "runStopNow": "إيقاف المهمة",
    "tackExecutionStart": "المهمة قيد التشغيل",
    "tackExecutionStop": "تم إيقاف تنفيذ المهمة",
    "dehumidification": "إزالة الرطوبة",
    "airSupply": "تزويد الهواء",
    "masterControl": "الرئيسي:",
    "powerSupply": "الطاقة",
    "lockScreen": "قفل",
    "RecordingControl": "تحكم في التسجيل",
    "RecordingControlSystem": "نظام التقاط المحاضرات",
    "LiquidCrystal": "شاشة LCD تفاعلية",
    "projector": "جهاز عرض",
    "othertype": "آخر",
    "childLock": "قفل الأطفال",
    "energySaving": "توفير الطاقة",
    "signalSourceSwitching": "مصدر الإدخال",
    "other": "ميزات أخرى:",
    "otherFunction": "وظيفة",
    "send": "إرسال",
    "ON": "تشغيل",
    "OFF": "إيقاف",
    "btnAddSchedule": "استعادة",
    "EditSchedulelist": "تحرير المجدول",
    "AddSchedulelist": "إضافة مجدول",
    "RestoreSchedulelist": "استعادة",
    "btn": "إلغاء",
    "btnNewList": "مجدول جديد",
    "ListName": "الاسم",
    "Cannotquit": "إلزامي",
    "NOCannotquit": "لا",
    "ListValidityPeriod": "فترة الصلاحية",
    "ListDescription": "الوصف",
    "currentSchedule": "قائمة المجدولين",
    "historySchedule": "قائمة التاريخ",
    "selectTime": "الوقت",
    "selectTimeTable": "الوقت",
    "taskType": "نوع المهمة",
    "selectBroadcasting": "البث",
    "selectDeviveControl": "تحكم الجهاز",
    "newSchedule": "مهمة جديدة",
    "newChecklist": "قائمة التحقق الجديدة",
    "titleStatus": "الحالة",
    "titleType": "النوع",
    "titleStartTime": "وقت البدء",
    "titleEndTime": "وقت الانتهاء",
    "titleRepeat": "تكرار",
    "titleName": "الاسم",
    "titleAction": "الإجراء",
    "tableEnabled": "مفعل",
    "tablePaused": "معلق",
    "tableEdit": "تحرير",
    "tableDelete": "حذف",
    "tableVolumeEdit": "حجم الصوت للبث",
    "tableBroadcastTitle": "العنوان",
    "tableBroadcastContent": "المحتوى",
    "tableBroadcastList": "القائمة",
    "tableBroadcast": "إجباري",
    "btnRemoveCompletely": "إزالة تمامًا",
    "btnEnabled": "المهمة الممكنة",
    "btnPaused": "تعطيل المهمة",
    "btnDelete": "حذف",
    "repeat0": "الاثنين",
    "repeat1": "الثلاثاء",
    "repeat2": "الأربعاء",
    "repeat3": "الخميس",
    "repeat4": "الجمعة",
    "repeat5": "السبت",
    "repeat6": "الأحد",
    "dialogTitleAdd": "مهمة تحكم الأجهزة الجديدة",
    "dialogTitleEdit": "تحرير مهمة تحكم الأجهزة",
    "newBroadcastingSchedule": "مهمة بث جديدة",
    "editBroadcastingSchedule": "تحرير مهمة البث",
    "chooseDevice": "اختيار الجهاز",
    "timeSetting": "إعداد الوقت",
    "controlBroadcasting": "خيار البث",
    "controlOption": "خيار التحكم",
    "scheduleName": "اسم المهمة:",
    "destination": "الوجهة",
    "timeTilte": "الوقت",
    "repeatTitle": "إعادة التكرار",
    "dialogRepeat0": "الاثنين",
    "dialogRepeat1": "الثلاثاء",
    "dialogRepeat2": "الأربعاء",
    "dialogRepeat3": "الخميس",
    "dialogRepeat4": "الجمعة",
    "dialogRepeat5": "السبت",
    "dialogRepeat6": "الأحد",
    "dialogOnceType": "مرة واحدة",
    "dialogRepeatType": "إعادة التكرار",
    "Manual": "يدوي",
    "ManualContent": "يمكنك تنفيذ هذه المهام يدويًا بمجرد الانتهاء من الإعداد.",
    "mainPower": "الطاقة الرئيسية",
    "powerControl": "تحكم الطاقة",
    "tableDisplayInputSwitch": "تحويل مدخل العرض",
    "tableAirConditioning": "جهاز التكييف",
    "tableProjectionScreen": "شاشة العرض",
    "tableElectronicLock": "القفل الكهربائي",
    "interactiveFlatPanel": "لوحة مسطحة تفاعلية",
    "displayInputSwitch": "تحويل مدخل العرض",
    "speakerVolume": "حجم الصوت",
    "MICVolume": "حجم الميكروفون",
    "ProjectionScreen": "شاشة العرض",
    "ElectronicLock": "القفل الكهربائي",
    "AirConditioning": "جهاز التكييف",
    "AirConditioningPower": "الطاقة",
    "AirConditioningModel": "النموذج",
    "AirConditioningTEMP": "درجة الحرارة",
    "AirConditioningFanSpeed": "سرعة المروحة",
    "OPEN": "فتح",
    "CLOSE": "إغلاق",
    "UP": "أعلى",
    "DOWN": "أسفل",
    "PowerOFF": "إيقاف",
    "PowerON": "تشغيل",
    "ModelAuto": "تلقائي",
    "ModelCool": "تبريد",
    "ModelHeat": "تسخين",
    "ModelAir": "من الجانب الهوائي",
    "TEMPLow": "منخفض",
    "TEMPMiddle": "متوسط",
    "TEMPHigh": "عالي",
    "btnSave": "حفظ",
    "btnNext": "التالي",
    "StartTime": "وقت البدء",
    "StopTime": "وقت التوقف",
    "Mandatory": "إجباري",
    "Video": "فيديو وصوت",
    "Notification": "إشعار",
    "btnFile": "اختر ملف وسائط",
    "LastingTime": "مدة",
    "textTitle": "عنوان",
    "textContent": "محتوى",
    "textTitleLetters": "أقل من 60 حرف",
    "textContentLetters": "أقل من 320 حرف",
    "CannotquitYES": "نعم",
    "CannotquitNo": "لا",
    "YES": "هل أنت متأكد أنك تريد حذف هذا المجدول؟",
    "No": "سيتم نقل المجدول المحذوف إلى قائمة التاريخ ويمكن استعادته",
    "delTitleContent": "حذف المجدول؟",
    "delTitleListContent": "حذف المجدول سيؤدي إلى مسح المهام المرتبطة به، يرجى التأكيد.",
    "deleListTitle": "هل أنت متأكد أنك تريد حذف هذا المجدول؟",
    "delTitleListContent1": "حذف؟",
    "deleListTitle1": "تأكيد",
    "delTitle": "الكل",
    "btnConfirm": "البث",
    "coxAll": "تحكم الأجهزة",
    "coxBroadcasting": "نعم",
    "coxDeviveControl": "لا",
    "rdMandatory": "تاريخ البدء",
    "noRdMandatory": "تاريخ الانتهاء",
    "startDate": "-",
    "endedDate": "النوع",
    "or": "اختر الوقت",
    "broadcastingType": "اختر التاريخ",
    "ChooseTime": "مجدول جديد",
    "ChooseDate": "تحرير المجدول",
    "newScheduleList": "الاسم",
    "editScheduleList": "فترة الصلاحية",
    "listName": "الوصف",
    "listValidityPeriod": "إلغاء",
    "listDescription": "تأكيد",
    "cancel": "إلغاء",
    "confirm": "تأكيد",
    "save": "حفظ",
    "addSuccess": "تم الإضافة بنجاح!",
    "addError": "فشل الإضافة!",
    "editSuccess": "تم التحرير بنجاح!",
    "editError": "فشل التحرير!",
    "delSuccess": "تم الحذف بنجاح!",
    "delError": "فشل الحذف!",
    "restoreSuccess": "تم استعادة قائمة الجداول بنجاح",
    "restoreError": "فشل استعادة قائمة الجداول",
    "restoreTitleContent": "هذا الوقت يتعارض مع الوقت في الجدول، الرجاء اختيار الوقت مرة أخرى",
    "Enabled": "مفعل",
    "Paused": "مؤقت",
    "Title": "العنوان:",
    "Content": "المحتوى:",
    "errorScheduleNameRequired": "يجب تعبئة اسم المهمة",
    "errorDeviceRequired": "يرجى اختيار الجهاز المستهدف",
    "deleTitle": "هل أنت متأكد من أنك تريد حذف هذه المهمة؟",
    "loopList": "قائمة الحلقات",
    "errorPleaseDateRange": "يرجى اختيار فترة التاريخ",
    "addError_2009": "اسم المجدول مكرر",
    "conflicts": "وقت المهمة يتعارض مع التالي:",
    "Pleaseagain": "يرجى إدخال مرة أخرى",
    "errorScheduleName": "اسم المهمة",
    "errorListName": "اسم المجدول",
    "today": "اليوم",
    "yesterday": "أمس",
    "thisWeek": "هذا الأسبوع",
    "lastWeek": "الأسبوع الماضي",
    "lastMonth": "الشهر الماضي",
    "thisMonth": "هذا الشهر",
    "times": "مرات",
    "TimeConflicts": "تعارضات الوقت",
    "editError_2006": "لم يتم العثور على الجهاز",
    "editError_2010": "اسم المهمة مكرر",
    "editError_2100": "المهمة انتهت صلاحيتها، لا يمكن البدء بها.",
    "ListTimeExpired": "انتهت صلاحية وقت المجدول، يرجى اختيار الوقت مرة أخرى",
    "TimeExpired": "انتهت صلاحية الوقت",
    "ControlOption": "مفقودة خيارات التحكم",
    "Pleaseleastone": "يرجى اختيار خيار تحكم واحد على الأقل",
    "Enter": "إدخال",
    "TitleFilled": "يجب تعبئة العنوان",
    "ContentFilled": "يجب تعبئة المحتوى",
    "PleaseMediaFile": "يرجى اختيار ملف الوسائط",
    "PleaseSchedule": "يرجى اختيار مهمة",
    "delTitleScheduleContent": "لا يمكن استرجاع المهمة المحذوفة.",
    "deleTitleSchedule": "هل أنت متأكد من أنك تريد حذف هذه المهمة؟",
    "deleteScheduleTitle": "يرجى اختيار المهمة للحذف",
    "PleaseFillColumn": "يرجى تعبئة اسم المجدول",
    "PleaseDate": "يرجى اختيار التاريخ",
    "Previous": "السابق",
    "RemoteControl": "التحكم عن بعد",
    "taskhasexpired": "انتهت صلاحية هذه المهمة، يرجى الاتصال بالمبدع لتحديث الوقت.",
    "execute": "تنفيذ",
    "broadcastingList": "قائمة البث",
    "volumeSuccess": "تم ضبط الصوت بنجاح",
    "volumeFailed": "فشل ضبط الصوت"
  },
  "live": {
    "StreamingRoom": "غرفة البث المباشر",
    "btnAddNewRoom": "إضافة غرفة جديدة",
    "Steaming": "البث المباشر",
    "Creater": "المضيف:",
    "Address": "عنوان RTMP:",
    "StreamingURL": "رابط البث المباشر:",
    "DestinationNMP": "اختيار الوجهة NMP:",
    "stop": "إيقاف",
    "stat": "تشغيل",
    "btnCope": "انقر لنسخ",
    "QRcode": "رمز الاستجابة السريعة",
    "Refresh": "تحديث",
    "AddNewRoomTitle": "إضافة غرفة بث جديدة",
    "editNewRoomTitle": "تحرير غرفة البث",
    "roomName": "اسم الغرفة:",
    "cancel": "إلغاء",
    "confirm": "تأكيد",
    "save": "حفظ",
    "delTitleContent": "هل أنت متأكد أنك تريد حذف هذا الجدول؟",
    "delTitle": "حذف؟",
    "delCancelButton": "إلغاء",
    "delConfirmButton": "تأكيد",
    "addSuccess": "تم الإضافة بنجاح!",
    "addError": "فشل في الإضافة!",
    "editSuccess": "تم التحرير بنجاح!",
    "editError": "فشل في التحرير!",
    "delSuccess": "تم الحذف بنجاح!",
    "delError": "فشل في الحذف!",
    "Stopstreaming": "إيقاف البث المباشر",
    "Startstreaming": "بدء البث المباشر",
    "error2504": "تعذر الحصول على عنوان البث المباشر من خادم الوسائط",
    "error2505": "اسم غرفة البث المتكرر",
    "error2506": "تم شغل الجهاز بواسطة إشارة بث أخرى",
    "error1900": "المعلمة المستلمة فارغة",
    "error2503": "تعذر الحصول على معلومات الخادم الوسائط",
    "error2507": "عنوان البث المباشر مكرر",
    "copySuccess": "تم نسخ المحتوى إلى الحافظة.",
    "copyError": "المتصفح لا يدعم النسخ التلقائي",
    "flashControl": "الفلاش غير مثبت أو مفعل. يرجى المحاولة بعد التثبيت أو التفعيل.",
    "liveStreaming": "لم يتم العثور على مصدر للبث المباشر.",
    "btnflash": "تثبيت/تفعيل",
    "serverAddress": "عنوان الخادم",
    "addressKey": "المفتاح:",
    "watchingAddress": "عنوان المشاهدة",
    "audioOnly": "صوت فقط",
    "enterTheKey": "يجب ملء المفتاح."
  },
  "guidepages": {
    "next": "الجهاز التالي للتحكم",
    "next1": "محاولة التحكم التالية",
    "next2": "البث التالي",
    "next3": "بدء البث التالي",
    "next4": "إيقاف البث التالي",
    "next5": "البث النصي التالي",
    "next6": "إعداد المهمة التالية",
    "next7": "إضافة مهمة جديدة التالية",
    "next8": "قائمة السجل التالية",
    "next9": "التخزين السحابي التالي",
    "next10": "البث المباشر التالي",
    "next11": "إعداد البث المباشر التالي",
    "exit": "خروج",
    "guideContent": "محتوى الدليل",
    "btnHomepage": "الصفحة الرئيسية",
    "btnDevices": "الأجهزة",
    "btnBroadcast": "البث",
    "btnSchedule": "الجدول الزمني",
    "btnResources": "الموارد",
    "btnStreaming": "البث المباشر",
    "btnPrevious": "السابق"
  },
  "privacy": {
    "PrivacyPolicy": "Q-NEX Privacy Policy",
    "Byusing": "By using the Q-NEX service, you are trusting us to process your information. We understand that this responsibility is important, so we have been committed to protecting your information and giving you control.",
    "whatinformation": "This Privacy Policy is designed to help you understand what information we collect, why it is collected, and how you manage your information.",
    "EffectiveDate": "Effective Date: January 1, 2020",
    "title1": "Q-NEX Respects Your Privacy",
    "title1Respects1": "Returnstar Interactive Technology Group Co.,Ltd. and its sub-brand (collectively “Q-NEX”, “we” or “us”) respect your privacy and understand that the processing and security of your personal data is important to you. Please review the full Privacy Policy below for more complete details on how we collect, use, share, and protect your personal data, as well as the choices you have regarding our use and sharing of your personal data, along with other important considerations.",
    "title1Respects2": "This Privacy Policy explains Q-NEX’s practices regarding the processing (such as the collection, use, storage, copy or disclosure) of your personal data received: (i) through our website https://www.qnextech.com (“Website”), email, and other written or in person communications; (ii) in the context of all our commercial relations with customers, end-users, dealers, distributors, suppliers, contractors, agents or representatives; and (iii) in the normal course of any other potential business relationship. We commit to comply with our obligations under all applicable Privacy and Data Protection Laws, as described below, including but not limited to the Provisions on Protection of Personal Information of Telecommunications and Internet Users, and to respect your rights whenever we are processing your personal data.",
    "title2": "Privacy and Data Protection",
    "title2Respects1": "“Personal Data” means any information that identifies, or can be used to identify, an individual.",
    "title2Respects2": "“Privacy and Data Protection Laws” means any and/or all laws, rules, directives and regulations, on any local, provincial, state, federal or national level within and outside the People's Republic of China, pertaining to data privacy, data security and/or the protection of Personal Data. Among them, laws and regulations outside China include but not limited to: (a) the General Data Protection Regulation (GDPR) and each European Union Member States’ national implementation thereof; (b) the Australian Privacy Act 1988 (Cth) and the Australian Privacy Amendment (Enhancing Privacy Protection Act) (2012); (c) the Belgian Privacy Law of 8 December 1992; (d) the Canadian Personal Information Protection and Electronic Documents Act, SC 2000, c 5 (PIPEDA); (e) the Personal Data Protection Act 2012 of Singapore (PDPA); (f) additional privacy and data protection laws applicable to a data subject’s location; and (g) any successor legislation or regulations applicable thereto.",
    "title3": "When Do We Collect Your Personal Data?",
    "title3Respects1": "Q-NEX may collect your personal data when you communicate with us by phone, e-mail, the Website or otherwise, in the context of:",
    "title3a": "Browsing our Website or visiting our social media sites;",
    "title3b": "Corresponding with Q-NEX;",
    "title3c": "Visiting one of our offices, events or facilities;",
    "title3d": "Registering for and/or participating in our conferences, events, training or other activities;",
    "title3e": "Requesting information, support, service, materials, assistance or other inquiries;",
    "title3f": "Subscribing to a newsletter or other mailing list;",
    "title3g": "Exchanging business cards;",
    "title3h": "Completing Website contact forms, questionnaires, surveys, or contest entry forms or otherwise participating in these activities;",
    "title3i": "Engaging in commercial relationships or other collaboration;",
    "title3j": "Ordering or registering Q-NEX products;",
    "title3k": "Creating or registering an account;",
    "title3l": "Uploading or downloading files;",
    "title3m": "Verification of your identity as a data subject; or",
    "title3n": "Using Q-NEX products that are connected to the Internet, including mobile apps, cloudware, and certain hardware devices.",
    "title4": "Which Types of Personal Data are Processed by Us?",
    "title4Respects1": "Q-NEX may process the following personal data:",
    "title4a": "Name, surname, title, company, email address, phone number (mobile and landline), address, signature and other contact information;",
    "title4b": "IP addresses;",
    "title4c": "Location data;",
    "title4d": "Cookie ID;",
    "title4e": "Language;",
    "title4f": "Personal preferences regarding communications and/or products and services;",
    "title4g": "Financial details (e.g. payment information, bank account number, and credit information);",
    "title4h": "Personal data regarding projects using Q-NEX products and services;",
    "title4i": "Personal data provided in your submissions, responses and feedback;",
    "title4j": "Personal data regarding your interactions with Q-NEX, including your use of the Website and of Q-NEX’s products or services;",
    "title4k": "Social media data, images, photos, and camera footage; and",
    "title4l": "Any other personal data provided by you or by your authorized Q-NEX dealer or service provider.",
    "title4Respects2": "For the avoidance of doubt, Q-NEX does not collect any sensitive personal data, such as racial or ethnic origin; political opinions; religious or philosophical beliefs; genetic characteristics; health information; sexual preferences; information about children; criminal convictions; or biometric data, and we explicitly ask that you not provide us with such data in your responses or feedback to us.",
    "title5": "How Do We Use Your Personal Data?",
    "title5Respects1": "In order to better manage our own business needs and to better communicate with you, we may collect, analyze, use and otherwise process your personal data for the following purposes:",
    "title5a": "To respond to your inquiries, questions and other requests;",
    "title5b": "To optimize and manage the quality and content of our Website, including the ability to personalize and secure your Website experience;",
    "title5c": "To create and maintain your website, customer and product accounts and registrations;",
    "title5d": "To provide you with marketing, advertising, promotions, programs, offers and other opportunities; including newsletters, information on products and services, subscriptions, training, updates and direct marketing, which may be targeted, based on your communication preferences;",
    "title5e": "To conduct customer satisfaction studies, surveys and other market research;",
    "title5f": "To manage our events and activities, and invite you to events;",
    "title5g": "To register visitors to our offices, facilities and events;",
    "title5h": "To create promotional materials, including videos, photos, articles, case studies, newsletters and other materials regarding projects or events;",
    "title5i": "To provide products, services, training, technical support, customer service and other assistance;",
    "title5j": "To manage and perform our agreements and obligations;",
    "title5k": "To respond to and follow up on business leads, opportunities, and contacts;",
    "title5l": "To process payments, orders, invoicing, returns, collection and other requests;",
    "title5m": "To provide pricing, quotations and custom configurations of our products and services;",
    "title5n": "To grant you access to our software, training, technical information and other proprietary content;",
    "title5o": "To evaluate, troubleshoot, analyze and improve the use, functionality, features, and performance of our products, services, training, technical support and customer service;",
    "title5p": "To gather, analyze and maintain configuration and backup data regarding our products and services;",
    "title5q": "To facilitate planning, analytics, forecasting and reporting regarding our products and services;",
    "title5r": "To use for our internal business operations and processes, including business and financial recordkeeping, data management and business continuity; and",
    "title5s": "To meet our legal and regulatory obligations.",
    "title6": "Which Legal Basis Applies To Our Processing Of Your Personal Data?",
    "title6Respects1": "The following legal grounds might apply to the processing of your personal data for the purposes mentioned above:",
    "title6a": "Processing is necessary for the performance of your agreement with us or in order to take all pre-contractual steps;",
    "title6b": "Processing takes place based upon our legitimate interest (comply with obligations, maintain business records, fraud prevention, network and information security, etc.). When carrying out this type of processing, we strive to strike a balance between this legitimate interest and respect for your privacy;",
    "title6c": "You have given your consent to the processing (e.g. in case of direct marketing, for the processing of analytic cookies and for data transfers to third parties);",
    "title6d": "In order to comply with our legal obligations (such as tax administration and record retention); or",
    "title6e": "In very exceptional circumstances to protect your vital interest or that of someone else.",
    "titel7": "To Whom Do We Disclose Your Personal Data?",
    "title7Respects1": "Q-NEX may disclose your personal data to yourself, to Q-NEX’s affiliates or to third parties, such as payment providers, software providers, cloud partners, transport partners, financial institutions, insurance companies, legal services, or certain other service providers or partners that Q-NEX has a strategic relationship with, in order to fulfill our relationship with you in the most effective way.",
    "title7Respects2": "Q-NEX will not disclose to third parties any personal data you submit for purposes other than those described in this Privacy Policy. If, in the future, we intend to disclose your personal data to third parties for any purpose other than those described in this Privacy Policy we shall inform you thereof in advance and ask your consent if required.",
    "title7Respects3": "Notwithstanding the foregoing, Q-NEX will disclose your personal data to a third party (such as competent authorities) if required to do so by law, during a legal proceeding, or if, in good faith, Q-NEX believes that such action is necessary to comply with certain laws, rules or regulations.",
    "titel8": "Which Guarantees Do We Provide in Case of International Data Transfers?",
    "title8Respects1": "Q-NEX is a global company and we may transfer your information to Q-NEX affiliates, representatives or third party contractors who represent us worldwide. Each affiliate, representative, or third party contractor works closely with Q-NEX, and any transfer of personal data between these associated entities will comply with applicable Privacy and Data Protection Laws.",
    "title8Respects2": "If any transfer of the personal data of residents of the European Economic Area (EEA) is made to a person or entity located in a country outside of the EEA, that is not recognized as providing an adequate level of protection, we will provide for increased information security and appropriate contractual provisions to strengthen data protection. To ensure that any such transfers of the personal data of EEA residents are compliant with the applicable Privacy and Data Protection Laws, we will either (i) conclude a data transfer agreement, based upon the EU model agreements, (ii) adopt binding corporate rules, (iii) rely on legally determined exceptions (such as requesting your explicit consent) or (iv) adopt other mechanisms which have been deemed to provide for the adequate protection of your personal data.",
    "titel9": "How Do We Secure Your Personal Data?",
    "title9Respects1": "We use a variety of security technologies and precautions, such as the Secure Socket Layer (SSL) protocol (encryption), to help protect your personal data from loss, theft, misuse and unauthorized access, in accordance with industry standards. To protect any personal data stored on Q-NEX servers or cloud-based storage, we regularly monitor our systems for vulnerabilities or attacks, and implement up to date information security measures.",
    "title9Respects2": "Access to personal data that is processed by Q-NEX is limited only to those of its employees, contractors and affiliated organizations that need to know that information in order to process it on Q-NEX’s behalf, in accordance with this Privacy Policy, and that have agreed not to disclose it to others.",
    "titel10": "How Long Do We Retain Your Personal Data?",
    "title10Respects1": "Unless a longer retention period is required by law, Q-NEX will retain your personal data for as long as needed to fulfil the relevant purposes described in this Privacy Policy.",
    "titel11": "Use of Cookies",
    "title11Respects1": "Q-NEX uses cookies on our Website, both to enable the site to work properly, and to enhance your experience while visiting our Website. Cookie file(s), which are stored on the hard drive of your computer, enable us to obtain information about your usage of our Website, and to measure and improve the performance of our Website. Cookies enable you to store your preferences, in order to enable our Website to recognize these preferences when you browse our Website.",
    "title11Respects2": "You may refuse to accept cookies by activating the setting on your browser which allows you to refuse cookies. However, if you select this setting you may not be able to access certain sections or features of our Website. Unless you have adjusted your browser setting so that it will refuse cookies, our system will issue cookies to your computer whenever you log on to our Website.",
    "title11Respects3": "When you visit our Website for the first time you will be provided with a link to this cookie policy and will have the opportunity to change your browser settings to refuse cookies. By continuing to browse our website without changing your settings, you agree to our use of cookies as explained in this policy.",
    "title11Respects4GoogleAnalytics": "Google Analytics.",
    "title11Respects4": "We use industry standard web analytics to track visits to our sites, namely those provided by Google Analytics. The information generated by the cookies about your use of our Website (including your IP address) will be transmitted to and stored by Google Analytics on their servers and is handled in accordance with Google’s Privacy Policy which can be accessed at the following link: https://policies.google.com/privacy.",
    "titel12": "Third Party Links on our Website",
    "title12Respects1": "The Website contains links to other websites. Q-NEX is not responsible for the privacy policy of other websites, or the manner in which they store, use or distribute information. Q-NEX encourages you to review the privacy policy of any website you may visit.",
    "titel13": "Children’s Information",
    "title13Respects1": "Q-NEX’s Website is not intended for use by children, and its products and services are not sold to children. In accordance with the Children’s Online Privacy Protection Act, we do not collect or maintain information from persons we know are under 18, and no part of the Website is designed to attract anyone under age 18.",
    "titel14": "What Are Your Rights and How Can You Exercise Them?",
    "title14Respects1": "If you are a natural person, you have the right at all times to be informed about the personal data we process about you, and to the extent authorized under the applicable Privacy and Data Protection Laws, to request access, modification, limitation of processing, transfer or deletion of personal data, or to object to the processing of your personal data, subject to the exceptions within the applicable Privacy and Data Protection Laws.",
    "title14Respects2": "If processing is based solely on your consent, you also have the right to revoke your consent at any time, without prejudice to the lawfulness of processing prior to revocation.",
    "title14Respects3": "Through the contact options listed below, you can exercise the above rights regarding the processing of your personal data by Q-NEX, except in cases where this would require a disproportionate effort on the part of Q-NEX.",
    "title14Respects4": "Please feel free to use the contact information listed below if you have any additional concerns regarding your personal data or your exercise of the above rights, and we will do our best to assist you.",
    "title14Respects5": "If you contact us to exercise one of your rights under the applicable Privacy and Data Protection Laws, we will reply within one (1) month. In certain exceptional circumstances, we may take up to three (3) months to fully respond to you, but in such case we shall inform you why we require additional time to respond in our initial reply.",
    "title14Respects6": "If we are unable to resolve an inquiry or request, where applicable, you may have the right to lodge a complaint with the local data protection authority.",
    "titel15": "Stay Informed of Changes in Our Privacy Policy",
    "title15Respects1": "In a world in which technology and legislation is constantly changing, this Privacy Policy may also change. We invite you to always consult the latest version of this policy, posted at https://www.qnextech.com/legal, and we will inform you of any changes via our Website or other common communication channels.",
    "titel16": "Contact Q-NEX",
    "title16Respects1": "If you have questions and/or comments about this Privacy Policy or the manner in which Q-NEX collects, uses and/or processes your personal data, please contact us:",
    "title16Respects2": "Via e-mail: info@qnextech.com"
    }
}



// WEBPACK FOOTER //
// ./src/lang/ar.js